import branchRuleActions from '../actions/BranchRuleActions';

export default function branchRuleReducer(state = { actionInProgress: undefined }, action) {
    switch (action.type) {
    case branchRuleActions.types.BRANCH_RULES_SET_ACTION_IN_PROGRESS:
        return Object.assign({}, state, { actionInProgress: action.actionInProgress });

    case branchRuleActions.types.BRANCH_RULES_SET_HAS_EVALUATED:
        return Object.assign({}, state, { hasEvaluated: action.hasEvaluated });

    default:
        return state;
    }
}
